import React, { memo } from "react";
import { css } from "@emotion/core";
import WithStyles from "shared/components/WithStyles";
import { TEXTS } from "shared/components/Footer/constants";
import { FONTS } from "shared/styles/base";

import SubSection from "./SubSection";

const qrCss = css`
    font-family: ${FONTS.CERA};
    font-size: 0.85rem;
    color: #fff;
`;

function NewsLetter() {
    return (
        <SubSection title={TEXTS.FOR_QUERIES}>
            <WithStyles cssProps={qrCss}>
                <div>
                    {TEXTS.CONTACT} | {TEXTS.EMAIL}
                </div>
                <div>{TEXTS.AVAILABILITY}</div>
            </WithStyles>
        </SubSection>
    );
}

export default memo(NewsLetter);
